export default __webpack_public_path__ + "static/media/home.4e177245.svg";